<!--
 * @Description:
 * @Author: Rfan
 * @Date: 2020-12-10 15:52:06
 * @LastEditTime: 2020-12-10 16:01:31
-->

<template>
  <div class="pages service">
    <div class="container">
      <h1>自动续费规则</h1>
      <ol class="main-list">
        <li>
          <h2>自动续订服务名称、时长、价格说明</h2>
          <p>
            画世界Pro会员服务有3种订购方式可供选择：13元/1个月、38元/3个月、143元/12个月。
          </p>
        </li>
        <li>
          <h2>到期自动续订说明</h2>
          <ol>
            <li>
              购买自动续订会员的账号，会在到期前24小时，自动续订并扣除相应费用（扣除费用参考上文中“自动续订服务名称、时长、价格说明”）。
            </li>
            <li>
              如已开通1个月画世界Pro会员自动续订服务，则会员服务到期前自动从账户扣费并延长1个月会员有效期。在不同时间点购买不同月份的自动续订会员服务情况下，将以最后开通的自动续订会员服务为准。如已开通1个月会员自动续订，在本月又开通了1个月会员自动续订，则服务到期前自动从账户扣费并延长1个月会员有效期。
            </li>
          </ol>
        </li>
        <li>
          <h2>如何取消自动续订</h2>
          <ol>
            <li>
              如需取消自动续订，请至少提前24小时操作取消。您可通过下述方式中止或终止本服务：
            </li>
            <li>
              苹果应用内支付（IAP支付，in-app
              purchase）自动续订用户退订方法如下： 打开苹果手机“设置” -->
              进入“iTunes Store 与 App Store”-->点击 “Apple ID”，选择"查看Apple
              ID"，进入"账户设置"页面，点击“订阅”，选择会员取消订阅即可。
            </li>
          </ol>
        </li>
        <li>
          <h2>其他</h2>
          <p>同一个appleid只能给一个画世界Pro用户开通自动续订服务。</p>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "Term",
  components: {},
  computed: {},
  created() {},
  methods: {}
};
</script>

<style lang="scss">
.service {
  .container {
    h1 {
      font-size: 24px;
    }

    li {
      a {
        color: #1989fa;
        text-decoration: none;
      }
    }

    ul {
      margin-top: 1em;
      padding-left: 0;

      li {
        &::before {
          content: "";
        }
      }
    }
  }
}
</style>
